(function () {
  'use strict';

  // True while selectVariant() re-dispatches change events to keep the desktop and mobile forms in sync.
  var syncing = false;

  function money(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function all(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function imageKey(value) {
    if (!value) return '';
    try {
      var url = new URL(value, window.location.origin);
      ['width', 'height', 'crop'].forEach(function (parameter) {
        url.searchParams.delete(parameter);
      });
      return url.hostname + url.pathname;
    } catch (error) {
      return String(value).split('?')[0];
    }
  }

  function sanitizeQuantity(value) {
    var quantity = Math.floor(Number(value));
    return Number.isFinite(quantity) && quantity >= 1 ? quantity : 1;
  }

  function init(root) {
    if (root.dataset.clBuyboxReady === 'true') return;
    root.dataset.clBuyboxReady = 'true';

    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-cl-variants]').textContent || '[]');
    } catch (error) {
      variants = [];
    }

    function findVariant(id) {
      return variants.find(function (variant) {
        return String(variant.id) === String(id);
      });
    }

    function findVariantFromOptions(card) {
      var optionSelects = all('[data-cl-option-select]', card);
      if (!optionSelects.length) return null;
      return variants.find(function (variant) {
        return optionSelects.every(function (select) {
          var index = Number(select.dataset.optionPosition) - 1;
          return String(variant.options[index]) === String(select.value);
        });
      });
    }

    function activateMedia(card, mediaId, source) {
      all('[data-cl-thumb]', card).forEach(function (thumb) {
        var idMatches = mediaId && thumb.dataset.mediaId
          && String(thumb.dataset.mediaId) === String(mediaId);
        var sourceMatches = !mediaId || !thumb.dataset.mediaId
          ? imageKey(thumb.dataset.image) === imageKey(source)
          : false;
        thumb.classList.toggle('is-active', Boolean(idMatches || sourceMatches));
      });
    }

    function updateMainImage(card, source, width, height, alt, mediaId) {
      var imageHost = card.querySelector('[data-cl-main-image]');
      var image = imageHost && imageHost.querySelector('img');
      if (!image || !source) return;

      image.src = source;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      if (width) image.width = width;
      if (height) image.height = height;
      if (typeof alt === 'string') image.alt = alt;
      activateMedia(card, mediaId, source);
    }

    function setMainImage(card, variant) {
      var media = variant && variant.featured_media;
      var featured = media && (media.preview_image || media);
      if (!featured || !featured.src) featured = variant && variant.featured_image;
      if (!featured || !featured.src) return;
      var mediaId = media && media.id;
      mediaId = mediaId || (variant.featured_image && variant.featured_image.id);
      updateMainImage(card, featured.src, featured.width, featured.height, featured.alt || '', mediaId);
    }

    function setQuantities(value) {
      var quantity = sanitizeQuantity(value);
      all('[data-cl-quantity]', root).forEach(function (input) {
        input.value = quantity;
      });
      return quantity;
    }

    function restoreSubmitState(form) {
      var submit = form.querySelector('[data-cl-submit]');
      var label = form.querySelector('[data-cl-submit-label]');
      if (!submit) return;
      var input = form.querySelector('[data-cl-variant-id]');
      var variant = input && findVariant(input.value);
      var available = variant ? variant.available : submit.dataset.variantAvailable !== 'false';
      var loading = submit.classList.contains('is-loading');
      submit.disabled = loading || !available;
      if (label && !loading) {
        label.textContent = available ? submit.dataset.defaultLabel : submit.dataset.soldOutLabel;
      }
    }

    function selectVariant(id, updateUrl) {
      var variant = findVariant(id);
      if (!variant) return;

      all('[data-cl-buy]', root).forEach(function (card) {
        var input = card.querySelector('[data-cl-variant-id]');
        var select = card.querySelector('[data-cl-variant-select]');
        var submit = card.querySelector('[data-cl-submit]');
        var submitLabel = card.querySelector('[data-cl-submit-label]');
        var price = card.querySelector('[data-cl-price]');
        var compare = card.querySelector('[data-cl-compare]');

        if (input && String(input.value) !== String(variant.id)) {
          input.value = variant.id;
          // Notify app listeners on the other form too; the guard stops our own select handler re-entering.
          syncing = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          syncing = false;
        }
        if (select) select.value = variant.id;
        all('[data-cl-option-select]', card).forEach(function (optionSelect) {
          var index = Number(optionSelect.dataset.optionPosition) - 1;
          if (variant.options && variant.options[index] !== undefined) {
            optionSelect.value = variant.options[index];
          }
        });
        all('[data-cl-variant-button]', card).forEach(function (button) {
          var active = String(button.dataset.variantId) === String(variant.id);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        all('[data-cl-sku]', card).forEach(function (sku) {
          sku.textContent = variant.sku || '';
        });
        if (price) price.textContent = money(variant.price);
        if (compare) {
          var onSale = Number(variant.compare_at_price) > Number(variant.price);
          compare.hidden = !onSale;
          compare.textContent = onSale ? money(variant.compare_at_price) : '';
        }
        if (submit) {
          submit.dataset.variantAvailable = variant.available ? 'true' : 'false';
          submit.disabled = submit.classList.contains('is-loading') || !variant.available;
        }
        if (submitLabel && (!submit || !submit.classList.contains('is-loading'))) {
          submitLabel.textContent = variant.available
            ? submit.dataset.defaultLabel
            : submit.dataset.soldOutLabel;
        }
        setMainImage(card, variant);
      });

      if (updateUrl && window.history && window.URL) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(window.history.state, '', url.toString());
      }
    }

    all('[data-cl-submit]', root).forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    });

    all('[data-cl-variant-button]', root).forEach(function (button) {
      button.addEventListener('click', function () {
        selectVariant(button.dataset.variantId, true);
      });
    });

    all('[data-cl-variant-select]', root).forEach(function (select) {
      select.addEventListener('change', function () {
        if (syncing) return;
        selectVariant(select.value, true);
      });
    });

    all('[data-cl-option-select]', root).forEach(function (select) {
      select.addEventListener('change', function () {
        if (syncing) return;
        var variant = findVariantFromOptions(select.closest('[data-cl-buy]'));
        if (variant) selectVariant(variant.id, true);
      });
    });

    all('[data-cl-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        all('[data-cl-buy]', root).forEach(function (card) {
          updateMainImage(
            card,
            thumb.dataset.image,
            thumb.dataset.imageWidth,
            thumb.dataset.imageHeight,
            null,
            thumb.dataset.mediaId
          );
        });
      });
    });

    all('[data-cl-quantity-step]', root).forEach(function (button) {
      button.addEventListener('click', function () {
        var input = button.closest('.cl-pdp-buy__quantity-control').querySelector('[data-cl-quantity]');
        var value = sanitizeQuantity(input.value);
        setQuantities(value + parseInt(button.dataset.clQuantityStep, 10));
      });
    });

    all('[data-cl-quantity]', root).forEach(function (input) {
      input.addEventListener('input', function () {
        if (input.value !== '') setQuantities(input.value);
      });
      input.addEventListener('change', function () {
        setQuantities(input.value);
      });
    });

    all('.js-product-samples', root).forEach(function (host) {
      function normalizeSampleLabel() {
        all('button, a', host).forEach(function (button) {
          // Only write when the text actually differs: writing triggers this observer again.
          var text = button.textContent.trim();
          if (text !== 'Get a Sample' && text.toUpperCase() === 'GET A SAMPLE') {
            button.textContent = 'Get a Sample';
          }
        });
      }

      normalizeSampleLabel();
      if (window.MutationObserver) {
        new MutationObserver(normalizeSampleLabel).observe(host, { childList: true, subtree: true });
      }
    });

    all('[data-cl-product-form]', root).forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (!window.fetch || !window.FormData || !window.Promise) return;
        event.preventDefault();

        var submit = form.querySelector('[data-cl-submit]');
        var label = form.querySelector('[data-cl-submit-label]');
        var message = form.querySelector('[data-cl-message]');
        if (!submit || submit.disabled || submit.classList.contains('is-loading')) return;

        var quantityInput = form.querySelector('[data-cl-quantity]');
        var quantity = setQuantities(quantityInput ? quantityInput.value : 1);
        var formData = new FormData(form);
        var submittedVariantId = String(formData.get('id') || '');
        submit.classList.add('is-loading');
        submit.disabled = true;
        if (message) message.textContent = '';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData,
          credentials: 'same-origin'
        })
          .then(function (response) {
            return response.text().then(function (text) {
              var body = {};
              try {
                body = text ? JSON.parse(text) : {};
              } catch (error) {
                body = {};
              }
              if (!response.ok) {
                var description = body.description || body.message || body.errors || text;
                if (description && typeof description !== 'string') description = JSON.stringify(description);
                throw new Error(description || 'Could not add to cart.');
              }
              return body;
            });
          })
          .then(function (item) {
            submit.classList.remove('is-loading');
            var currentInput = form.querySelector('[data-cl-variant-id]');
            var currentVariant = currentInput && findVariant(currentInput.value);
            var unchanged = currentInput && String(currentInput.value) === submittedVariantId;
            restoreSubmitState(form);
            if (label && unchanged && (!currentVariant || currentVariant.available)) {
              label.textContent = 'Added ✓';
            }
            form.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: { variant: item, quantity: quantity }
            }));
            window.setTimeout(function () {
              restoreSubmitState(form);
            }, 1800);
          })
          .catch(function (error) {
            submit.classList.remove('is-loading');
            restoreSubmitState(form);
            if (message) message.textContent = error.message || 'Could not add to cart. Please try again.';
          });
      });
    });

    var dialog = root.querySelector('[data-cl-guarantee-dialog]');
    if (dialog) {
      all('[data-cl-guarantee-open]', root).forEach(function (button) {
        button.addEventListener('click', function () {
          if (dialog.open) return;
          if (dialog.showModal) dialog.showModal();
          else dialog.setAttribute('open', '');
        });
      });
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var rectangle = dialog.getBoundingClientRect();
        var onBackdrop = event.clientX < rectangle.left
          || event.clientX > rectangle.right
          || event.clientY < rectangle.top
          || event.clientY > rectangle.bottom;
        if (!onBackdrop) return;
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      });
    }
  }

  function start() {
    var tabs = document.querySelector('.cl-pdp-tabs');
    if (tabs && !document.getElementById('cl-pdp-tabs')) tabs.id = 'cl-pdp-tabs';
    all('[data-cl-buybox]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
